module.exports = {
  AntDesign: require('./AntDesign.ttf'),
  Entypo: require('./Entypo.ttf'),
  EvilIcons: require('./EvilIcons.ttf'),
  Feather: require('./Feather.ttf'),
  FontAwesome: require('./FontAwesome.ttf'),
  Foundation: require('./Foundation.ttf'),
  Ionicons: require('./Ionicons.ttf'),
  MaterialCommunityIcons: require('./MaterialCommunityIcons.ttf'),
  MaterialIcons: require('./MaterialIcons.ttf'),
  SimpleLineIcons: require('./SimpleLineIcons.ttf'),
  Octicons: require('./Octicons.ttf'),
  Zocial: require('./Zocial.ttf'),
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-web-vector-icons/fonts/index.js
 ** module id = 1372
 ** module chunks = 0
 **/